import { ReactNode } from "react";
import { Container, Content, Description, StyledImg, Title } from "./style";
import noDataImage from "../../../assets/images/capivara-min.png";

type ContainerNoDataProps = {
  title?: string;
  description?: string;
  isData: boolean;
  children: ReactNode;
  width?: string;
  height?: string;
};

export const ContainerNoData: React.FC<ContainerNoDataProps> = ({
  title = "Nenhum dado cadastrado.",
  description = "Após o primeiro cadastro, você poderá visualizar aqui.",
  isData,
  children,
  width = "100%",
  height = "68vh",
}) =>
  isData ? (
    <>{children}</>
  ) : (
    <Container width={width} height={height}>
      <Content>
        <StyledImg src={noDataImage} alt="Ilustração nenhum dado" />
        <Title>{title}</Title>
        <Description>{description}</Description>
      </Content>
    </Container>
  );
